import { productAddToListLinkStyles as styles } from "@insite/content-library/Components/ProductAddToListLink";
import { IconWrapper } from "@insite/mobius/Icon";
import Plus from "@insite/mobius/Icons/Plus";
import getColor from "@insite/mobius/utilities/getColor";
import { commonLinkStyles, customLinkHoverStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.link = {
    ...styles.link,
    css: css`
        ${styles.link?.css}
        ${commonLinkStyles}
        font-size: 10px;
        line-height: 18px;

        ${mediaQueriesBP.minMD} {
            font-size: 12px;
            line-height: 29px;
        }

        &:hover {
            ${IconWrapper} {
                background-color: ${getColor(colorStrings.commonPrimarySecond)};
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        }
    `,
    icon: {
        iconProps: {
            color: colorStrings.commonGlobalWhite,
            src: Plus,
            size: 16,
            css: css`
                background-color: ${getColor(colorStrings.primaryMain)};
                border-radius: 50%;
                margin-right: 4px;

                svg {
                    height: 14px;
                }
            `,
        },
        position: "left",
    },
};
